import React, { useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const aboutHeroBackgroundRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (aboutHeroBackgroundRef.current) {
        const scrolled = window.pageYOffset;
        const parallax = scrolled * 0.5;
        aboutHeroBackgroundRef.current.style.transform = `translateY(${parallax}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="about">
      <section className="about-hero">
        <div 
          ref={aboutHeroBackgroundRef}
          className="about-hero-background"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/compass_cloth.jpg)`
          }}
        ></div>
        <div className="container">
          <h1>About UpNorth Impact</h1>
          <p className="hero-description">
            Philanthropic advisory and management consulting to help transform generous intentions into meaningful, effective action.
          </p>
        </div>
      </section>

      <section className="about-content">
        <div
          className="about-content-background"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/topo_map.png)`
          }}
          aria-hidden="true"
        />
        <div className="container">
          <div className="about-section">
            <h2>Athan Lindsay</h2>
            <p>
              Athan Lindsay is a Chartered Advisor in PhilanthropyⓇ, a national accreditation that equips advisors to assist their clients by using financial planning, estate planning, and gift planning to advance their personal financial goals while also having a positive impact on their community.
            </p>
            <p>
              With over 25 years of experience, Athan is a recognized leader, speaker, educator, and advocate in the field of philanthropy. He has worked locally, regionally, and nationally with family, community, and health legacy foundations.
            </p>
            <p>
              Athan played a key leadership role in a national rural funders collaborative to leverage $100 million to support rural communities and families.
            </p>
            <p>
              He is the architect and visionary behind the BIG Equity Fund and was a cofounded the the Community Investment Network. Both initiatives engage donors of color as philanthropists to use collective philanthropy to fund the impact they want to see in their communities.
            </p>
            <p>
              Athan was recognized with the 2006 Emerging Leader Award by the Association of Black Foundation Executives and was chosen to be part of the 2023 Council on Foundations’ Career Pathways Cohort.
            </p>

            <div className="about-feature-card">
              <img
                className="about-feature-card__image"
                src={`${process.env.PUBLIC_URL}/images/athan_lindsay_headshot.png`}
                alt="Athan Lindsay headshot"
                loading="lazy"
              />
              <div className="about-feature-card__body">
                <p>
                  As the founder of Up North Impact, I draw on 30 years of expertise in the impact space to guide philanthropists toward creating more just and caring communities. My work supports individuals, families, foundations, and their advisors by transforming generous intentions into meaningful, effective action. I partner with clients who are ready to engage in a learning-based process, using their words and actions to build bridges, not widen gaps.
                </p>
                <p>
                  With decades of experience in the nonprofit sector and foundations, I help donors move past reactive giving to a more intentional and discerning process. I guide them to form philanthropic strategies that are rooted in their values, informed by best practices, and designed to achieve their desired impact. This approach fosters a more purposeful philanthropy, creating intentional and meaningful contributions.
                </p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>Our Clients</h2>
            <p>I work with clients at various stages of their philanthropic journey, including:</p>
            <ul>
              <li>
                <strong>Emerging philanthropists:</strong> Individuals, families, and foundations who are discovering their purpose and values to inform their giving.
              </li>
              <li>
                <strong>Experienced donors:</strong> Philanthropists seeking to elevate their impact with new knowledge, systems thinking, and tailored strategies.
              </li>
            </ul>
            <p>
              Regardless of their stage, my goal is to help clients move beyond reactive responses toward a focused and discerning practice that amplifies their impact.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
